import { render } from "./Changeline.vue?vue&type=template&id=0f36c2d2&scoped=true"
import script from "./Changeline.vue?vue&type=script&lang=js"
export * from "./Changeline.vue?vue&type=script&lang=js"

import "./Changeline.vue?vue&type=style&index=0&id=0f36c2d2&lang=less&scoped=true"

import exportComponent from "D:\\28\\前端\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f36c2d2"]])

export default __exports__